import React from "react";
import {
  Box,
  Button,
  Card,
  Typography,
  IconButton,
  Grid,
  AspectRatio,
} from "@mui/joy";
import DeleteIcon from "@mui/icons-material/Delete";
import { Upload } from "@mui/icons-material";
import imageCompression from "browser-image-compression";
import heic2any from "heic2any";

const GaleriaImagenes = ({ imagenes, onChange, setFormdata }) => {
  // Maneja la carga de archivos, convierte y comprime imágenes antes de agregarlas
  const handleFileChange = async (event) => {
    const archivos = Array.from(event.target.files);
    let imagenesProcesadas = [];

    for (let archivo of archivos) {
      let imagenRecibida = archivo;

      try {
        // Convertir HEIC/HEIF a JPG
        if (
          imagenRecibida.type === "image/heic" ||
          imagenRecibida.type === "image/heif"
        ) {
          const blob = await heic2any({
            blob: imagenRecibida,
            toType: "image/jpeg",
            quality: 0.8,
          });
          imagenRecibida = new File([blob], "imagen_convertida.jpg", {
            type: "image/jpeg",
          });
        }

        // Opciones de compresión
        const opciones = {
          maxSizeMB: 1, // Máximo 1MB
          maxWidthOrHeight: 1024, // Redimensionar si es necesario
          useWebWorker: true,
          fileType: "image/jpeg", // Convertir a JPG si es necesario
        };

        // Comprimir la imagen
        const imagenComprimida = await imageCompression(
          imagenRecibida,
          opciones
        );
        imagenesProcesadas.push(imagenComprimida);
      } catch (error) {
        console.error("Error al procesar la imagen:", error);
      }
    }

    onChange([...imagenes, ...imagenesProcesadas]); // Agregar imágenes procesadas a la galería
  };

  // Maneja la eliminación de imágenes
  const handleEliminarImagen = (indice) => {
    setFormdata((valorprevio) => ({
      ...valorprevio,
      imagenes_eliminadas: [
        ...valorprevio.imagenes_eliminadas,
        imagenes[indice]?.name ?? imagenes[indice],
      ],
    }));
    const nuevaGaleria = imagenes.filter((_, i) => i !== indice);
    onChange(nuevaGaleria);
  };

  let url = process.env.REACT_APP_FRONTEND_URL;
  let linkimagen = process.env.REACT_APP_DOSPACES;

  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ mb: 1 }}>
        <Typography level="title-md">Galería de imágenes</Typography>
        <Typography level="body-sm">
          Sube imágenes para mostrar en tu perfil. Puedes agregar o eliminar
          imágenes de la galería.
        </Typography>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
        <Button
          color="neutral"
          variant="outlined"
          component="label"
          startIcon={<Upload />}
        >
          Subir imágenes
          <input
            type="file"
            multiple
            hidden
            accept="image/*"
            onChange={handleFileChange}
          />
        </Button>
      </Box>
      <Grid container spacing={2}>
        {imagenes.map((imagen, index) => (
          <Grid item xs={6} md={4} key={index}>
            <Card sx={{ position: "relative" }}>
              <AspectRatio ratio="4/3">
                <img
                  src={
                    typeof imagen === "string"
                      ? `${linkimagen}/uploads/` + imagen
                      : URL.createObjectURL(imagen)
                  }
                  alt={`Imagen ${index}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                />
              </AspectRatio>
              <IconButton
                size="sm"
                color="danger"
                onClick={() => handleEliminarImagen(index)}
                sx={{ position: "absolute", top: 5, right: 5 }}
              >
                <DeleteIcon />
              </IconButton>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default GaleriaImagenes;
